<template>
  <router-link
      :to="url"
      @click.stop.prevent
      class="text-inherit hover:text-primary"
    >
  <div class="flex items-center  hover:text-primary">
    {{ params.value }}
  </div>
  </router-link>
</template>

<script>
export default {
  name: 'CellRendererLink',
  computed: {
    url () {
      //return '/apps/user/user-view/268'

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      return `/admin/settings/categories/view/${  this.params.data ? this.params.data.id : ''}`
    }
  }
}
</script>
